<template>
    <v-checkbox v-model="model" dense
                :error-messages="validationErrors"
                @change="emitChangeEvent"
                stack-label outlined class="mr-4">
        <template v-slot:label>
            <span v-html="valueItem.labelText" />
        </template>
    </v-checkbox>
</template>
<script>
    export default {
        props: {
            valueItem: {
                type: Object,
                default: function () {
                    return {
                        label: "",
                        labelText: "",
                        isRequired: false,
                        requiredError: "",
                        error: "",
                        hasError: false,
                        value: false
                    };
                },
            },
        },
        computed: {
            model: {
                get() {
                    return this.valueItem.value;
                },
                set(value) {
                    this.valueItem.value = value;
                }
            },
            validationErrors() {
                const errors = [];
                this.checkForErrors(this.valueItem);
                if (this.valueItem.hasError) errors.push(this.valueItem.error);
                return errors;
            },
        },
        methods: {
            checkForErrors: (vi) => {
                if (vi.isRequired && !vi.value) {
                    vi.hasError = true;
                    vi.error = vi.requiredError;
                    return;
                }
                vi.hasError = false;
                vi.error = "";
            },
            emitChangeEvent: function () {
                this.$emit('change');
            }
        }
    }
</script>
